"use client";

import { useEffect, useState } from "react";

import { Breakpoints } from "@types";

export const useBreakpoint = (): number => {
  const [breakpoint, setBreakpoint] = useState(Breakpoints.mobile);

  useEffect(() => {
    const checkBreakpoint = () => {
      if (window.innerWidth < Breakpoints.mobile) {
        setBreakpoint(Breakpoints.mobile);
      } else if (window.innerWidth < Breakpoints.tablet) {
        setBreakpoint(Breakpoints.tablet);
      } else {
        setBreakpoint(Breakpoints.desktop);
      }
    };

    window.addEventListener("resize", checkBreakpoint);
    checkBreakpoint();

    return () => {
      window.removeEventListener("resize", checkBreakpoint);
    };
  }, []);

  return breakpoint;
};
